
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {getAllproyecto5tlxff } from '../../api/proyecto5tlxff.api'
import {customlistadoporproyectoao513_69385435e30724925008ce6b } from '../../api/gastoporproyectooezl4.api'

import './transparenciai2sojk.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Ptransparenciai2sojk = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyendpoint_693853a8e30724925008cdbb, setLoftyEndpoint_693853a8e30724925008cdbb] = useState([]);
		const [loftyres_69385435e30724925008ce6b_component_in40ik, setloftyres_69385435e30724925008ce6b_component_in40ik] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_693853a8e30724925008cdbb = await getAllproyecto5tlxff({ token: loftytoken || 'asdsa' });
			setLoftyEndpoint_693853a8e30724925008cdbb(loftyres_693853a8e30724925008cdbb.data);
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadoporproyectoao513_69385435e30724925008ce6b({
				});
				setloftyres_69385435e30724925008ce6b_component_in40ik(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id693852ee8e5aed52dc8ae82a" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
        <a
          target=""
          className=""
          id="iumht8"
          href="/"
        >
          
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
        </a>
        
      <div id="itmdc" className="">
      
        <a
          target=""
          className="link-menu "
          id="iijdu7"
          href="/sobrenosotros"
        >
          
    <div id="inoik6" className="">
    <>Quienes Somos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ijau3l"
          href="/proyectos"
        >
          
    <div id="i1h6oa" className="">
    <>Proyectos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i3lnta"
          href="/campanas"
        >
          
    <div id="iunupg" className="">
    <>Campañas</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="imshx9"
          href="/impacto"
        >
          
    <div id="itxxvc" className="">
    <>Impacto Social</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ioow1d"
          href="/convenios"
        >
          
    <div id="inwnb2" className="">
    <>Convenios</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ip93t8"
          href="/transparencia"
        >
          
    <div id="ienp1j" className="">
    <>Transparencia</>
    </div>
    
        </a>
        
      </div>
      
        <a
          target=""
          className="boton-primario "
          id="iiit99"
          href="/contacto"
        >
          
    <div id="i1fieg" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/proyectos"
        type=""
      >
        <>Proyectos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/campanas"
        type=""
      >
        <>Campañas</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/impacto"
        type=""
      >
        <>Impacto social</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/convenios"
        type=""
      >
        <>Convenios</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/transparencia"
        type=""
      >
        <>Transparencia</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ingwtg">
        <>Transparencia y Gestión Financiera</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3m0i" className="">
      
      <div className="" id="i83s7t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i2uc23">
        <>Compromiso con la transparencia</>
      </span>
      
      </div>
      
      <div className="" id="ij3u7q">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iz4tof">
        <>La Asociación VICAMPAZ rinde cuentas periódicamente a sus asociados y aliados institucionales. A continuación se presenta un resumen de los aportes, gastos e inversiones realizadas durante el periodo 2020.</>
      </span>
      
      </div>
      
      </div>
      
      <div id="iuo301" className="">
      
        <div id="il2k6q" className="">
        
          {
            loftyendpoint_693853a8e30724925008cdbb.map((loftyitem) => (
              <div key={loftyitem._id} className="" id="i9lfy2">
                
      <div
        id="ir0pdh"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
        <div className="" id="ilhk5e">
          
          <div className="" id="">
            {loftyitem.titulo3z2yk}
          </div>
          
        </div>
        
        <div className="" id="igd4zi">
          
          <div className="" id="if1meu">
            {loftyitem.descripcino606tl}
          </div>
          
        </div>
        
        <div id="in40ik" className="">
        
            {
              loftyres_69385435e30724925008ce6b_component_in40ik.map((loftyitem_69385435e30724925008ce6b_component_in40ik) => (
                <div key={loftyitem_69385435e30724925008ce6b_component_in40ik._id} className="" id="iyysvi">
                  
        <div className="" id="igpski">
          
          <div className="" id="">
            {loftyitem_69385435e30724925008ce6b_component_in40ik?.titulo}
          </div>
          
        </div>
        
      <div id="ip07kl" className="">
      
      <div className="" id="i93l2r">
        
      </div>
      
        <div className="" id="i7l587">
          
          <div className="" id="">
            {loftyitem_69385435e30724925008ce6b_component_in40ik?.monto}
          </div>
          
        </div>
        
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      <div id="ilz9i4" className="">
      
      <div className="" id="ilb373">
        
      </div>
      
        <div className="" id="inawhl">
          
            <div className="" id="ip8zpb">
              {parseFloat(loftyitem.monto)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        
      </div>
      
      </div>
      
              </div>
            ))
          }
          
        </div>
        
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        
      <span className="" id="icvuhe">
        <>Fundación Petrus</>
      </span>
      
      </div>
      
      <img
        className=""
        id="imlyex"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="invc11" className="">
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Páginas</>
      </div>
      
      <div className="" id="igdgp1">
        <>Quienes Somos</>
      </div>
      
      <div className="" id="io8u0g">
        <>Proyectos</>
      </div>
      
      <div className="" id="ifh4ms">
        <>Impacto Social</>
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Más información</>
      </div>
      
      <div className="" id="il1rnw">
        <>Contacto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Ptransparenciai2sojk);
  